import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BASE}/api`;

const api = axios.create({
  baseURL: API_URL,
});

let token = localStorage.getItem("token") || null;

export const setToken = (t) => {
  token = t;
  if (t) localStorage.setItem("token", t);
  else localStorage.removeItem("token");
};

export const getToken = () => token;

api.interceptors.request.use((config) => {
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const formatErr = (err) => {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
};

// SEC hardening note: `?auth=<token>` in the URL is used ONLY for endpoints
// that need to load in an `<img src>` (logos, pricebook images) where browsers
// cannot send a custom Authorization header. Every backend endpoint that
// accepts this pattern now enforces token-type + user-lookup checks via
// `get_token_required` (see backend/server.py). Residual risk is limited to
// the token appearing in browser history and server access logs.
//
// For DOWNLOADS (PDFs, CSVs, ZIPs), prefer `secureDownload(path, filename)`
// below — it fetches via axios (Authorization header only) as a blob and
// triggers a native download without ever putting the token in a URL.
export const fileUrl = (path) => `${API_URL}${path}?auth=${encodeURIComponent(token || "")}`;

export const secureDownload = async (path, filename) => {
  const resp = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(resp.data);
  const a = document.createElement("a");
  a.href = url;
  if (filename) a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 1500);
};

export default api;
